import React, { useState, useEffect } from 'react';
import "../css/DCSAssigned.css";
import { Link, useLocation } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BASE_URL } from '../config';
import { getAuthHeaders } from '../services/useAuth';
import Loader from "../dist/Loader";
import CustomButton from './CustomButton';
const DCSAssigned = () => {
    const location = useLocation();
    const [states, setStates] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Fetch states on component mount
    useEffect(() => {
        setIsLoading(true);
        fetch(`${BASE_URL}/api/states`,{
          headers:getAuthHeaders()
        })
        .then(res => res.json())
        .then(data => {
            setStates(data);
            setIsLoading(false);
        })
        .catch(err => {
            console.error(err);
            setIsLoading(false);
        });
    }, []);

  // Fetch employees when state changes
    useEffect(() => {
        if (selectedState) {
        setIsLoading(true);
        fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`,{
          headers:getAuthHeaders()
        })
            .then(res => res.json())
            .then(data => {
            setEmployees(data);
            setIsLoading(false);
            })
            .catch(err => {
            console.error(err);
            setIsLoading(false);
            });
        } else {
        setEmployees([]);
        setSelectedEmployee('');
        }
    }, [selectedState]);
    
    
    const handleGoClick = () => {
        if (selectedState) {
        setIsLoading(true);
        let url = `${BASE_URL}/api/employee-assignments?state_id=${selectedState}`;
        
        // Add employee filter if selected
        if (selectedEmployee) {
            url += `&employee_id=${selectedEmployee}`;
        }

        fetch(url,{
          headers:getAuthHeaders()
        })
            .then(res => res.json())
            .then(data => {
            setTableData(data);
            setShowTable(true);
            setIsLoading(false);
            })
            .catch(err => {
            console.error(err);
            setIsLoading(false);
            });
        }
    };

  // Function to create clickable count links
const renderCountLink = (count, employeeId, type) => {
  // Determine the correct route based on type
  const routeMap = {
    doctors: '/doctordetails',
    chemists: '/chemistdetails',
    stockists: '/stockistdetails'
  };
  
  return (
    <Link 
      to={`${routeMap[type]}/${employeeId}`}
      state={{
        fromDCSAssigned: true,
        selectedState,
        selectedEmployee,
        tableData,
        states,
        employees,
        showTable: true
      }}
      className="DCSAssigned-count-link"
    >
      {count}
    </Link>
  );
};
    
 useEffect(() => {
  if (location.state) {
    // restore if coming back from any detail page
    if (
      location.state.fromDoctorDetails ||
      location.state.fromChemistDetails ||
      location.state.fromStockistDetails
    ) {
      setSelectedState(location.state.selectedState || '');
      setSelectedEmployee(location.state.selectedEmployee || '');
      setTableData(location.state.tableData || []);
      setShowTable(true);
    }
    // Clear history state to avoid re-use on refresh
    window.history.replaceState({}, document.title);
  } else {
    // Hard refresh
    setSelectedState('');
    setSelectedEmployee('');
    setTableData([]);
    setShowTable(false);
  }
}, [location.state]);



    // Restore state when returning from DoctorDetails
   


    const handlePrint = () => {
        const printContents = document.getElementById("printableTable").innerHTML;
        const originalContents = document.body.innerHTML;
    
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(); // optional: reload to restore event bindings
    };

    const handleExport = () => {
        const worksheet = XLSX.utils.json_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Assignments");
    
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "employee_assignments.xlsx");
    };



  return (
    <div className="DCSAssigned--main-container">
     <>
  {isLoading && <Loader />} {/* Show Loader overlay */}
  

  <div className={`LocationHistorySMS-main-container ${isLoading ? "blur-sm pointer-events-none" : ""}`}>
      
      <div className="DCSAssigned-filter-container">
       <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
  <span className="text-blue-700"> Select </span>
  <span className="text-blue-500">State</span>
</h1>

        {isLoading ? (
          <div className="DCSAssigned-spinner-container">
            <div className="DCSAssigned-spinner" role="status">
              <span className="DCSAssigned-sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="DCSAssigned-filter-row">
              <label className="DCSAssigned-label">State:</label>
              <select 
                className="DCSAssigned-form-control" 
                value={selectedState}
                onChange={(e) => {
                  setSelectedState(e.target.value);
                  setShowTable(false);
                }}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>{state.name}</option>
                ))}
              </select>
            
              <label className="DCSAssigned-label">Employee:</label>
              <select 
                className="DCSAssigned-form-control" 
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
                disabled={!selectedState || employees.length === 0}
              >
                <option value="">Select Employee</option>
                {employees.map((employee) => (
                  <option key={employee.id} value={employee.id}>
                    {employee.first_name} {employee.last_name} | {employee.designation} | {employee.headquarter_name} | {employee.division} | {employee.state_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="DCSAssigned-button-container">
              <CustomButton
                className="DCSAssigned-btn DCSAssigned-btn-primary"
                onClick={handleGoClick}
                disabled={!selectedState}
                variant='go'
              >
                Go
              </CustomButton>
            </div>
          </>
        )}
      </div>

      {/* Table Section */}
      {showTable && (
        <>
          <div className="DCSAssigned-table-container">
            <div className="DCSAssigned-tabletitle-container">
              <h5 className="DCSAssigned-title1">
                State - {states.find(s => s.id === parseInt(selectedState))?.name} Assigned Doctors, Chemists and Stockists
              </h5>
            </div>
            <div className="DCSAssigned-table-responsive">
              <table className="DCSAssigned-table">
                <thead className="text-white">
                  <tr>
                    <th>S.NO</th>
                    <th>Employee</th>
                    <th>Division</th>
                    <th>Designation</th>
                    <th>Immediate Manager</th>
                    <th>HQ</th>
                    <th>City</th>
                    <th>No of Doctor</th>
                    <th>No of Chemist</th>
                    <th>No of Stockist</th>
                    {/* <th>SMS</th> */}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={row.employee_id}>
                      <td>{index + 1}</td>
                      <td>{row.employee_name}</td>
                      <td>{row.division}</td>
                      <td>{row.designation}</td>
                      <td>{row.immediate_manager}</td>
                      <td>{row.headquarter}</td>
                      <td>{row.city}</td>
                      <td>{renderCountLink(row.doctor_count, row.employee_id, 'doctors')}</td>
                      <td>{renderCountLink(row.chemist_count, row.employee_id, 'chemists')}</td>
                      <td>{renderCountLink(row.stockist_count, row.employee_id, 'stockists')}</td>
                      {/* <td>{row.sms || 'N/A'}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="DCSAssigned-action-buttons">
            <CustomButton
              variant="print"
              onClick={handlePrint}
            >
              Print
            </CustomButton>
            <CustomButton
              variant="export"
              onClick={handleExport}
            >
              Export to Excel
            </CustomButton>
          </div>
        </>
      )}
</div>
        </>
    </div>
  );
};

export default DCSAssigned;